import React from 'react';
import Banner from '../Components/Banner';
import { Link } from 'react-router-dom';

const WebhookStatus = () => {
    return (
        <>
            <Banner heading="Webhook Listener" text="API Status" />
            <div className="tmp-section-gap">
                <div className="container">
                    <div className="service-card-v2 text-center py-16 px-6 max-w-2xl mx-auto">
                        <div className="mb-8">
                            <span className="text-6xl">📡</span>
                        </div>
                        <h2 className="title mb-4">Webhook Endpoint</h2>
                        <h3 className="service-card-num mb-6">Status: Active (Awaiting System POST)</h3>
                        <p className="service-para mb-8 text-left">
                            <strong>Note for Developers:</strong> This URL is configured as a Listener for payment notifications.
                            If you are visiting this in a browser, you will see this page because browsers use <strong>GET</strong> requests.
                            The payment gateway will send <strong>POST</strong> notifications directly to the backend server.
                        </p>
                        <div className="bg-gray-100 p-4 rounded-xl mb-8 text-left border border-gray-200">
                            <p className="text-sm font-mono text-gray-600">
                                // Endpoint Purpose: Payment IPN / Webhook<br />
                                // Expected Method: POST<br />
                                // Backend URI: https://api.hnhtechsolutions.com/api/payment/webhook
                            </p>
                        </div>
                        <div className="flex flex-wrap justify-center gap-4">
                            <Link to="/" className="tmp-btn btn-primary">Back to Home</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WebhookStatus;
